import { Link } from 'react-router-dom';
import ActionButtons from './ActionButtons'; 

const BackIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16"><path fillRule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/></svg>;
const SettingsIcon = () => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M12.22 2h-.44a2 2 0 0 0-2 2v.18a2 2 0 0 1-1 1.73l-.43.25a2 2 0 0 1-2 0l-.15-.08a2 2 0 0 0-2.73.73l-.22.38a2 2 0 0 0 .73 2.73l.15.1a2 2 0 0 1 1 1.72v.51a2 2 0 0 1-1 1.74l-.15.09a2 2 0 0 0-.73 2.73l.22.38a2 2 0 0 0 2.73.73l.15-.08a2 2 0 0 1 2 0l.43.25a2 2 0 0 1 1 1.73V20a2 2 0 0 0 2 2h.44a2 2 0 0 0 2-2v-.18a2 2 0 0 1 1-1.73l.43-.25a2 2 0 0 1 2 0l.15.08a2 2 0 0 0 2.73-.73l.22-.39a2 2 0 0 0-.73-2.73l-.15-.08a2 2 0 0 1-1-1.74v-.5a2 2 0 0 1 1-1.74l.15-.09a2 2 0 0 0 .73-2.73l-.22-.38a2 2 0 0 0-2.73-.73l-.15.08a2 2 0 0 1-2 0l-.43-.25a2 2 0 0 1-1-1.73V4a2 2 0 0 0-2-2z"></path><circle cx="12" cy="12" r="3"></circle></svg>;

const MiniLogo = () => (
    <div style={{ textAlign: 'left', lineHeight: '0.9', userSelect: 'none' }}>
        <div style={{ 
            fontFamily: '"Segoe UI", Roboto, Helvetica, Arial, sans-serif', 
            fontWeight: '900', 
            fontSize: '1.4rem', 
            color: '#fff', 
            letterSpacing: '5px', // Harf arasını açmak fütüristik bir hava katar
            textTransform: 'uppercase', 
            backgroundImage: 'linear-gradient(to bottom, #fff, #38bdf8)', // Gradyan metin
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            filter: 'drop-shadow(0 0 5px rgba(56, 189, 248, 0.5))'
        }}>
            GUNES SPACE
        </div>
        <div style={{ 
            fontFamily: 'monospace', 
            fontSize: '0.5rem', 
            color: '#38bdf8', 
            letterSpacing: '6px', 
            textTransform: 'uppercase', 
            marginTop: '4px',
            fontWeight: 'bold'
        }}>
          KOZMİK FİLO - H. ALİ KARA
        </div>
    </div>
);

const ClassroomHeader = ({ selectedClass, onBack, students, onScoreChange, isEditMode, onToggleEditMode }) => {
    return (
        <header className="ct-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '15px 20px', borderBottom: '1px solid rgba(56, 189, 248, 0.15)', background: 'rgba(15, 23, 42, 0.4)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
                <Link to="/" style={{ textDecoration: 'none' }}>
                    <MiniLogo />
                </Link>

                {selectedClass && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        <span style={{ color: '#475569', fontSize: '1.5rem', fontWeight: '300' }}>/</span>
                        <button 
                            onClick={onBack} 
                            style={{ background: 'rgba(30, 41, 59, 0.6)', border: '1px solid rgba(56, 189, 248, 0.3)', color: '#38bdf8', padding: '6px 12px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', transition: 'all 0.2s', fontWeight: 'bold' }}
                            onMouseOver={(e) => e.currentTarget.style.background = 'rgba(56, 189, 248, 0.2)'}
                            onMouseOut={(e) => e.currentTarget.style.background = 'rgba(30, 41, 59, 0.6)'}
                            title="Filo Seçimine Dön"
                        >
                            <BackIcon /><span style={{ marginLeft: '5px' }}>Filolar</span>
                        </button>
                        <span style={{ color: '#475569', fontSize: '1.5rem', fontWeight: '300' }}>/</span>
                        <span style={{ fontWeight: '800', fontSize: '1.1rem', color: '#e0f2fe', textShadow: '0 0 10px rgba(56,189,248,0.4)' }}>{selectedClass}</span>
                    </div>
                )}
            </div>

            <div className="ct-header-right" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                {selectedClass && (
                    <>
                        {/* YENİ: DÜZENLEME MODU BUTONU */}
                        <button 
                            onClick={onToggleEditMode}
                            style={{ 
                                background: isEditMode ? 'rgba(239, 68, 68, 0.2)' : 'rgba(30, 41, 59, 0.6)', 
                                border: isEditMode ? '1px solid rgba(239, 68, 68, 0.5)' : '1px solid rgba(56, 189, 248, 0.3)', 
                                color: isEditMode ? '#fca5a5' : '#38bdf8', 
                                padding: '8px 12px', borderRadius: '8px', cursor: 'pointer', display: 'flex', alignItems: 'center', transition: 'all 0.2s', fontWeight: 'bold', gap: '6px'
                            }}
                            title="Öğrenci Düzenleme Modu"
                        >
                            <SettingsIcon /> <span>{isEditMode ? 'Düzenlemeyi Kapat' : 'Mürettebatı Düzenle'}</span>
                        </button>
                        
                        <ActionButtons students={students} onScoreChange={onScoreChange} />
                    </>
                )}
            </div>
        </header>
    );
};

export default ClassroomHeader;